/**
 * Ad data from SmartLib
 */
export interface AdData {
  adId: string
  adType: string
  clickUrl: string
  creativeId: string
  duration: number
  index: number
  nonLinearIframeResources: unknown[]
  nonLinearStaticResources: unknown[]
  skipPosition: number
  startPosition: number
}

/**
 * Ad break data from SmartLib
 */
export interface AdBreakData {
  adCount: number
  ads: AdData[]
  duration: number
  id: string
  startPosition: number
}

/**
 * Ad state for player
 */
export interface AdState {
  isAdPlaying: boolean
  isAdBreakActive: boolean
  currentAd: AdData | undefined
  currentAdBreak: AdBreakData | undefined
  isAdSkippable: boolean
}

/**
 * Empty ad state
 */
export const EMPTY_AD_STATE: AdState = {
  isAdPlaying: false,
  isAdBreakActive: false,
  currentAd: undefined,
  currentAdBreak: undefined,
  isAdSkippable: false,
}

/**
 * SmartLib configuration
 */
export interface SmartlibConfiguration {
  enabled?: boolean
  analyticsAddress?: string
  nanoCDNHost?: string
  broadpeakDomainNames?: string
}

/**
 * SmartLib plugin options
 */
export interface SmartlibPluginOptions extends SmartlibConfiguration {}

/**
 * SmartLib plugin interface
 */
export interface SmartlibPlugin {
  getState(): AdState
  skip(): void
  dispose(): void
}
